import { JobLogEvento } from '../generated/backend-enums.js';
export { JobLogEvento };
export const JobLogEventoMap = {
    [JobLogEvento.CRIADO]: 'Criado',
    [JobLogEvento.REATIVADO]: 'Reativado',
    [JobLogEvento.INATIVADO]: 'Inativado',
    [JobLogEvento.CLIENTE_ALTERADO]: 'Cliente alterado',
    [JobLogEvento.BRIEFING_ANEXADO]: 'Briefing anexado',
    [JobLogEvento.PAPER_ANEXADO]: 'Paper anexado',
    [JobLogEvento.ESTUDO_VERBA_ANEXADO]: 'Estudo de verba anexado',
    [JobLogEvento.PROJETO_EXECUTIVO_ANEXADO]: 'Projeto executivo anexado',
    [JobLogEvento.PROJETO_FINAL_ANEXADO]: 'Projeto final anexado',
    [JobLogEvento.PLANILHA_ADICIONADA]: 'Planilha adicionada',
    [JobLogEvento.ALTERADO]: 'Alterado',
    [JobLogEvento.DATA_EVENTO_CONFIRMACAO_DERRUBADA]: 'Confirmação da data do evento derrubada',
};
